export function setReservas(state, reservas) {
    state.reservas = reservas
}

export function setReservas22(state, reservas) {
    state.reservas22 = reservas
}

export function actListReservas(state, reserva) {
    if (reserva !== null) {
        const index = state.reservas.findIndex(r => r.id === reserva.id)
        if (index != -1) {
            state.reservas.splice(index, 1, reserva)
        }

        const index2 = state.reservas22.findIndex(r => r.id === reserva.id)
        if (index2 != -1) {
            state.reservas22.splice(index2, 1, reserva)
        }
    }

}

export function actEstadoListReservas(state, reserva) {
    if (reserva != null && reserva.estado_id) {
        const index = state.reservas.findIndex(r => r.id === reserva.id)
        if (index != -1) {
            state.reservas[index].estado_id = reserva.estado_id
            state.reservas[index].hora_inicio = reserva.hora_inicio
            state.reservas[index].hora_final = reserva.hora_final
        }

        const index2 = state.reservas22.findIndex(r => r.id === reserva.id)
        if (index2 != -1) {
            state.reservas22[index2].estado_id = reserva.estado_id
            state.reservas22[index2].hora_inicio = reserva.hora_inicio
            state.reservas22[index2].hora_final = reserva.hora_final
        }
    }
}


export function actPusherEstadoListReservas(state, data) {
    if (data != null && data.reserva_id != null) {
        const index = state.reservas.findIndex(r => r.id === data.reserva_id)
        if (index != -1) {
            state.reservas[index].estado_id = data.estado_id
            state.reservas[index].hora_inicio = data.hora_inicio
            state.reservas[index].hora_final = data.hora_final
        }

        const index2 = state.reservas22.findIndex(r => r.id === data.reserva_id)
        if (index2 != -1) {
            state.reservas22[index2].estado_id = data.estado_id
            state.reservas22[index2].hora_inicio = data.hora_inicio
            state.reservas22[index2].hora_final = data.hora_final
        }
    }
}

export function actPagoListReservas(state, reserva) {
    if (reserva != null && reserva.estado_id) {
        const index = state.reservas.findIndex(r => r.id === reserva.id)
        if (index != -1) {
            state.reservas[index].porcobrar = parseFloat(reserva.porcobrar).toFixed(2)
            state.reservas[index].pagoefectivo = parseFloat(reserva.pagoefectivo).toFixed(2)
            state.reservas[index].pagotarjeta = parseFloat(reserva.pagotarjeta).toFixed(2)
            state.reservas[index].formadepago = reserva.formadepago
        }

        const index2 = state.reservas22.findIndex(r => r.id === reserva.id)
        if (index2 != -1) {
            state.reservas22[index2].porcobrar = parseFloat(reserva.porcobrar).toFixed(2)
            state.reservas22[index2].pagoefectivo = parseFloat(reserva.pagoefectivo).toFixed(2)
            state.reservas22[index2].pagotarjeta = parseFloat(reserva.pagotarjeta).toFixed(2)
            state.reservas22[index2].formadepago = reserva.formadepago
        }
    }
}

export function actDeleteListReservas(state, id) {
    if (id != null) {
        const index = state.reservas.findIndex(r => r.id === id)
        if (index != -1) {
            state.reservas.splice(index, 1)
        }

        const index2 = state.reservas22.findIndex(r => r.id === id)
        if (index2 != -1) {
            state.reservas22.splice(index2, 1)
        }
    }
}



export function setReservaSelec(state, reserva) {
    state.reservaSelec = reserva
}

export function setMaterialesSelec(state, mat) {
    state.materialesSelec = mat
}

export function setTarifasSelec(state, tar) {
    state.tarifasSelec = tar
}




